import { useHistory, useLocation } from '@react-router';
import { useCallback, useMemo } from 'react';
import { ROW_ID_PARAM_NAME } from '../types';

export const useRowFilters = () => {
  const history = useHistory();
  const location = useLocation();

  const currentRow = useMemo(() => {
    const filters = new URLSearchParams(location.search);
    return filters.get(ROW_ID_PARAM_NAME);
  }, [location.search]);

  const setCurrentRow = useCallback(
    (newID: string | null) => {
      const filters = new URLSearchParams(location.search);
      const base = location.pathname;

      if (newID) {
        filters.set(ROW_ID_PARAM_NAME, newID);
      } else {
        filters.delete(ROW_ID_PARAM_NAME);
      }

      history.push(`${base}?${filters.toString()}`);
    },
    [history, location.pathname, location.search]
  );

  return { currentRow, setCurrentRow };
};
